import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hoursInput", "minutesInput", "totalInput", "button"]

  static values = {
    persisted: Boolean,
    initial: Number,
    disallowZero: Boolean
  }

  connect() {
    const initial = this.initialMinutes()
    if (this.currentTotalMinutes() === 0 && initial > 0) {
      this.setInputsFromTotal(initial)
    }
    this.sync()
  }

  sync() {
    const total = this.currentTotalMinutes()
    if (this.hasTotalInputTarget) {
      this.totalInputTarget.value = String(total)
    }

    if (!this.hasButtonTarget) return

    const changed = total !== this.initialMinutes()
    const shouldShowButton = !this.persistedValue || changed
    const disallowed = this.disallowZeroValue && total <= 0

    this.buttonTarget.classList.toggle("hidden", !shouldShowButton)
    this.buttonTarget.disabled = disallowed || !shouldShowButton
    this.buttonTarget.classList.toggle("opacity-40", disallowed)
  }

  submit(event) {
    const total = this.currentTotalMinutes()
    if (this.disallowZeroValue && total <= 0) {
      event.preventDefault()
    }
  }

  currentTotalMinutes() {
    const hours = this.parseWholeNumber(this.hoursInputTarget?.value)
    const minutes = this.parseWholeNumber(this.minutesInputTarget?.value)
    const clampedMinutes = Math.max(0, Math.min(59, minutes))
    return (hours * 60) + clampedMinutes
  }

  setInputsFromTotal(total) {
    const minutes = Number.isFinite(total) ? Math.max(0, total) : 0
    const hours = Math.floor(minutes / 60)
    const rem = minutes % 60
    if (this.hasHoursInputTarget) this.hoursInputTarget.value = String(hours)
    if (this.hasMinutesInputTarget) this.minutesInputTarget.value = String(rem)
  }

  parseWholeNumber(value) {
    const parsed = parseInt((value || "").trim(), 10)
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0
  }

  initialMinutes() {
    const value = this.hasInitialValue ? this.initialValue : 0
    return Number.isFinite(value) && value > 0 ? value : 0
  }
}
